import React from 'react';

import cardS from '../SubChannelCard/ChannelCard.scss';

import { CardItemStyle } from '../../models/subchannel';
import { FeedInstance } from '../../models/feed';
import { // Normal Items
    TextFeedItem,
    ImageFeedItem,
    FocusImage,
    // Loadings
    FocusImageLoading,
    TextCompLoading,
    TitleLoading,
    ItemImageLoading,
    LinkWrapper,
} from '.';

/**
 * Dispatch components by format.
 * @param format {CardItemStyle} - Switch between item components
 * @param article {FeedInstance} - pass this arg to child component.
 */
export const ItemDispatcher = (format: CardItemStyle, article: FeedInstance, _: number) => {
    if (!article) {
        return null;
    }
    const components = {
        'text': TextFeedItem,
        'image': ImageFeedItem,
        'focusImage': FocusImage,
    };
    return components[format]({ article });
};

export const ItemLoadingDispatcher = (format: CardItemStyle, _: any, index: number) => {
    const components = {
        'text': TextCompLoading,
        'image': ItemImageLoading,
        'focusImage': FocusImageLoading,
    };
    return components[format]({ index });
};

interface CardTitleProps {
    isLoading: boolean,
    name: string,
    link: string,
}

export const CardTitle = (props: CardTitleProps) => {
    const { isLoading, name, link } = props;
    const ChannelTitle = () => link ? <LinkWrapper href={link} className={cardS.title}>{name}</LinkWrapper> : <h3 className={cardS.title}>{name}</h3>;
    return (
        <>
            {!isLoading ? <ChannelTitle /> : <TitleLoading />}
        </>
    );
};

export const SubChannelTitle = (props: CardTitleProps) => {
    const { isLoading, name, link } = props;
    return (
        <>
            {!isLoading ? <LinkWrapper href={link}>{name}</LinkWrapper> : <TitleLoading />}
        </>
    );
};



// WEBPACK FOOTER //
// ./src/components/BaseComp/Common.tsx